import { useState } from "react";
import { Paper, Stack, Box, InputLabel, Button, useTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ArrowForward } from "@mui/icons-material";

const DateFilters = ({ onApplyFilters, onClearFilters }) => {
  const theme = useTheme();
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  const handleApply = () => {
    onApplyFilters(tempStartDate, tempEndDate);
  };

  const handleClear = () => {
    setTempStartDate(null);
    setTempEndDate(null);
    onClearFilters();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        bgcolor: "white",
      }}
    >
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="flex-end"
          flexWrap="wrap"
        >
          <Box sx={{ minWidth: 320 }}>
            <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
              Start Date
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={tempStartDate}
                onChange={(newValue) => setTempStartDate(newValue)}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ minWidth: 320 }}>
            <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
              End Date
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={tempEndDate}
                onChange={(newValue) => setTempEndDate(newValue)}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", gap: 1, mt: "20px" }}>
            {(tempStartDate || tempEndDate) && (
              <Button
                variant="outlined"
                onClick={handleClear}
                sx={{ color: "#7152F3" }}
              >
                Clear
              </Button>
            )}
            <Button
              variant="contained"
              onClick={handleApply}
              sx={{
                backgroundColor: "#7152F3",
              }}
            >
              Filter{" "}
              <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default DateFilters;
